/**
 * Mirrors ProjulV1Portal's src/app/shared/Utils/estimate-tax-mode.ts, minus its `taxModeForNewEstimate`:
 * this app only ever reads a stored mode, it never creates an estimate.
 */

export interface TaxModeCarrier {
  RequireTaxPerItemizedCostLineIsDisabled?: unknown;
}

/** The one parser: only an explicit false, however it is spelled, taxes every line. */
function parseTaxMode(value: unknown): boolean {
  return String(value).trim().toLowerCase() !== 'false';
}

/**
 * An estimate's stored `RequireTaxPerItemizedCostLineIsDisabled`: true taxes the whole document, false
 * taxes every line. A legacy estimate stored with no mode is whole-document tax; the account's setting is never read.
 */
export function estimateTaxMode(estimate: TaxModeCarrier | null | undefined): boolean {
  return parseTaxMode(estimate ? estimate.RequireTaxPerItemizedCostLineIsDisabled : undefined);
}

/** The same stored mode as every pricing entry point here takes it: true only when every line carries its own tax. */
export function estimateTaxesPerLine(estimate: TaxModeCarrier | null | undefined): boolean {
  return !estimateTaxMode(estimate);
}

/**
 * An invoice's own stored mode, as the server's totals engine reads it: per line unless the stored value is
 * explicitly true. A legacy invoice stored with no mode keeps pricing per line, so no stored money moves.
 */
export function invoiceTaxesPerLine(invoice: TaxModeCarrier | null | undefined): boolean {
  return String(invoice ? invoice.RequireTaxPerItemizedCostLineIsDisabled : undefined).trim().toLowerCase() !== 'true';
}
